import React from "react";

function Download() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#6C757D"
        fillRule="evenodd"
        d="M.563 9a.562.562 0 01.562.563V13.5a1.125 1.125 0 001.125 1.125h13.5a1.125 1.125 0 001.125-1.125V9.562a.563.563 0 011.125 0V13.5a2.25 2.25 0 01-2.25 2.25H2.25A2.25 2.25 0 010 13.5V9.562A.563.563 0 01.563 9z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#6C757D"
        fillRule="evenodd"
        d="M5.625 8.438a.562.562 0 01.795 0L9 11.018l2.58-2.58a.563.563 0 11.795.795L9.398 12.21a.564.564 0 01-.796 0L5.625 9.233a.563.563 0 010-.796z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#6C757D"
        fillRule="evenodd"
        d="M9 1.125a.563.563 0 01.563.563v9a.562.562 0 11-1.126 0v-9A.563.563 0 019 1.125z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default Download;
